export const main_color = "#8D0333";
export const almost_black = "#01010b";
export const text_primary_color = "#01010b";

export const button_color = "#0AB0AB";
export const white = "#FFFFFF";
export const input_red = "#eb5757";
export const almost_white = "#FFFAFF";
export const secondary_color = "#F1DAC4";

export const background = "#FFFFFF";
export const main_color_50 = "#8D033350";
export const secondary_color_50 = "#F1DAC450";
export const button_color_50 = "#0AB0AB50";

export const height_header = "4rem";